module.exports = __webpack_public_path__ + "img/TikTok.92e1d562.svg";